import "./Footer.css";
import linkedin from "../../img/linkedinDark.png";
import phone from "../../img/phoneDark.png";
import gmail from "../../img/gmailDark.png";
import twitter from "../../img/twitterDark.png";

function Footer() {
  return (
    <footer className="footer">
      <h2>Contacts</h2>
      <div className="footer-div">
        <p className="footer-phone">
          <a href="tel:+254723888354"  target="_blank" rel="noreferrer">
            <span>
              <img src={phone} alt="" />
            </span>
            <span>+254723888354</span>
          </a>
        </p>
        <p className="footer-gmail">
          <a  href="mailto: otieno.oduor.michael@gmail.com"  target="_blank" rel="noreferrer">
            <span>
              <img src={gmail} alt="" />
            </span>
            <span>otieno.oduor.michael@gmail.com</span>
          </a>
        </p>
        <p className="footer-gmail">
          <a  href="https://twitter.com/mikeotyeno"  target="_blank" rel="noreferrer">
            <span>
              <img src={twitter} alt="" />
            </span>
            <span>@mikeotyeno</span>
          </a>
        </p>
        <p className="footer-gmail">
          <a  href="https://www.linkedin.com/in/michael-oduor-otieno/"  target="_blank" rel="noreferrer">
            <span>
              <img src={linkedin} alt="" />
            </span>
            <span>Michael Otieno</span>
          </a>
        </p>

        {/* <p className="footer-icons">
         
          <a href="https://www.linkedin.com/in/michael-oduor-otieno/">
            <img src={linkedin} alt="" />
          </a>
        </p> */}
      </div>
    </footer>
  );
}

export default Footer;
